<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <el-row type="flex" class="row-bg" justify="space-between">
        <el-button size="mini" icon="el-icon-download" type="primary" plain @click="downUploadExcel"
          >下载模板</el-button
        >
      </el-row>
    </div>
    <div
      v-loading="loading"
      element-loading-text="查询中..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      class="fill-information-container"
    >
      <el-form label-width="140px" :rules="rules" :model="qszmFormData" ref="mainForm">
        <el-row type="flex" justify="center" :gutter="20">
          <el-col :span="12">
            <el-form-item label="权利人名称：" prop="qlrmc">
              <el-input v-model="qszmFormData.qlrmc" :disabled="flag"></el-input>
            </el-form-item>
            <el-form-item label="证件类型：" prop="zjzl">
              <dict-select v-model="qszmFormData.zjzl" type="证件种类" :disabled="flag"></dict-select>
            </el-form-item>
            <el-form-item label="证件号码：" prop="zjh">
              <el-input v-model="qszmFormData.zjh" :disabled="flag"></el-input>
            </el-form-item>
            <el-form-item label="查档用途：">
              <dict-select v-model="qszmFormData.cxyt" type="查档用途"></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center" :gutter="20">
          <el-col :span="8">
            <el-form-item label="上传文件：" prop="fileName">
              <el-input v-model="qszmFormData.fileName" :readonly="true" placeholder="文件名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-upload
              class="upload-demo"
              ref="upload"
              action="doUpload"
              :limit="1"
              :file-list="fileList"
              :before-upload="beforeUpload"
            >
              <el-button slot="trigger" type="primary" plain>选取文件</el-button>
            </el-upload>
          </el-col>
        </el-row>
      </el-form>
      <div class="text-center">
        <el-button type="primary" @click="submit" :loading="loading">提交</el-button>
      </div>
    </div>
  </el-card>
</template>

<script>
import { zxTemplate } from '@public/zsMould';
import hasPermission from '@iebdc/mixin/hasPermission';
import { localDataUser } from '@iebdc/utils/local-data';
import { mapGetters } from 'vuex';
import { bsdtDetail, multiCheckCertifies } from '@iebdc/api/qszmcx-service';
import { downloadMultiQszmcxExcel } from '@iebdc/api/file-service';
import { getCookie } from '@iebdc/utils/cookies';
export default {
  name: '',
  mixins: [hasPermission],
  props: {},
  data() {
    this.rules = {
      qlrmc: [{ required: true, message: '请输入权利人名称', trigger: 'blur' }],
      zjh: [{ required: true, message: '请输入证件号', trigger: 'blur' }],
      zjzl: [{ required: true, message: '请选择证件种类', trigger: 'change' }],
      fileName: [{ required: true, message: '请选择证件种类', trigger: 'change' }],
    };
    return {
      isSearch: false,
      formData: new FormData(),
      fordata: new FormData(),
      tempalteList: zxTemplate,
      qszmFormData: {
        phone: '', // 手机号
        bdcqzh: '', // 不动产权证号
        qydm: getCookie('selectedAreaCode'), // 区域代码
        qlrmc: '', // 权利人名称
        zjzl: '', // 证件种类(身份证)
        zjh: '', // 证件号(一般是身份证号)
        loginName: '', // 登录名
        cxyt: '', // 查档用途
        fileName: '', // 文件名称
      },
      loading: false,
      flag: false,
      user: localDataUser.get(),
      visible: false,
      fileName: '',
      fileList: [],
    };
  },
  computed: {
    ...mapGetters(['selectedBsdtCode']),
  },
  watch: {
    selectedBsdtCode() {
      this.getBsdtDetail();
    },
  },
  mounted() {
    this.getUser();
  },
  methods: {
    // 获取用户基本信息
    getUser() {
      this.getBsdtDetail();
      let loginName = JSON.parse(localStorage.getItem('IEBDC_USER_DATA')).loginName;
      this.qszmFormData.loginName = loginName;
      if (this.user.userCategory === 'FINANCIAL') {
        this.flag = true;
        this.qszmFormData.qlrmc = this.user.name;
        this.qszmFormData.zjzl = this.user.frmczjzl;
        this.qszmFormData.zjh = this.user.frzjh;
        this.qszmFormData.phone = this.user.tel;
        this.qszmFormData.loginName = this.user.loginName;
      } else if (this.user.userCategory === 'NORMAL') {
        this.flag = true;
        this.qszmFormData.qlrmc = this.user.name;
        this.qszmFormData.zjzl = this.user.zjzl;
        this.qszmFormData.zjh = this.user.zjh;
        this.qszmFormData.phone = this.user.tel;
        this.qszmFormData.loginName = this.user.loginName;
      } else {
        this.flag = false;
      }
    },
    beforeUpload(file) {
      // 上传前 文件校验
      const extension = file.name.split('.')[1] === 'xls';
      const extension2 = file.name.split('.')[1] === 'xlsx';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!extension && !extension2) {
        this.$message.warning('上传文件只能是 xls、xlsx格式!');
        return;
      }
      if (!isLt2M) {
        this.$message.warning('上传文件大小不能超过 2MB!');
        return;
      }
      this.qszmFormData.fileName = file.name;
      this.formData.append('file', file);
      return false; // 返回false不会自动上传
    },
    // 下载模板
    downUploadExcel() {
      downloadMultiQszmcxExcel().then((res) => {
        if (res.data && res.success) {
          window.open(res.data);
        }
      });
    },
    // 验证表单
    submit() {
      if (!this.selectedBsdtCode) {
        this.$message.warning('请选择办事大厅!');
        return;
      }
      this.$refs.mainForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.formData.append('qydm', this.qszmFormData.qydm);
          this.formData.append('qlrmc', this.qszmFormData.qlrmc);
          this.formData.append('zjh', this.qszmFormData.zjh);
          this.formData.append('zjzl', this.qszmFormData.zjzl);
          this.formData.append('loginName', this.qszmFormData.loginName);
          multiCheckCertifies(this.formData)
            .then((res) => {
              if (res.success) {
                this.formData = {};
                this.loading = false;
                this.$emit('qszmcbh', res.data);
                this.$emit('next', 2);
              } else {
                this.loading = false;
              }
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
    // 获取办事大厅信息
    getBsdtDetail() {
      // 获取办事大厅详情
      bsdtDetail({ officeCode: this.selectedBsdtCode }).then((res) => {
        if (res.success && res.data) {
          this.wddh = res.data.dh;
          this.wddz = res.data.address;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.fill-information-container {
  padding: 20px 140px;

  .lc-name {
    color: orange;
    margin-top: 20px;
  }

  .rz_img {
    margin-top: 10px;

    .rz_img_face {
      margin-left: 20px;
    }
  }

  /deep/ .el-select {
    width: 100%;
  }
}
/deep/.el-card__header {
  margin: 0 20px;
  padding: 18px 0px;
  border-bottom: 1px solid #ccc;
}
/deep/.el-card__body {
  padding: 10px 20px;
}
.top {
  border-bottom: 1px solid #ccc;
  .el-row {
    padding: 20px 0;
  }
}
.dialog-footer {
  display: flex;
  align-items: center;
}
.file {
  border: 1px solid #ccc;
}

.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}
.clearfix:after {
  clear: both;
}

.box-card {
  width: 100%;
}
.mt {
  margin: 20px 0;
  p {
    text-align: center;
    font-size: 20px;
  }
  a {
    color: #00bfff;
  }
}
.jzxx {
  text-align: center;
}
.mt30 {
  margin-top: 30px;
}

.dialog-footer div {
  margin: auto;
}
</style>
